module.exports = __webpack_public_path__ + "assets/default.1a6d5537.svg";